// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CheckOutlinedSvg from "@ant-design/icons-svg/es/asn/CheckOutlined";
import AntdIcon from '../components/AntdIcon';

var CheckOutlined = function CheckOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CheckOutlinedSvg
  }));
};

CheckOutlined.displayName = 'CheckOutlined';
export default React.forwardRef(CheckOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CheckOutlined.js
// module id = 753
// module chunks = 0